import React, { useState, useEffect, useRef } from 'react'
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const Fixtures = () => {
    const { fetchData, postData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [symbol, setSymbol] = useState('')
    const [withdrawals, setWithdrawals] = useState([])

    const navigate = useNavigate();

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/fixtures');
            setLoader(false);

            setWithdrawals(data.matches);
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, [])


    async function payAction(matchId, type) {
        let score = ''
        if (type) {
            score = prompt("Please enter a score before proceeding:");

            const isValid = /^[0-9]:[0-9]$/.test(score);

            if (!isValid) {
                alert("Invalid format. Please enter in format Number:Number (e.g., 1:2)");
                return;
            }
        }

        setLoader(true);

        try {
            const data = await postData('/admin/company/fixture', { matchId, score });
            setLoader(false);

            setWithdrawals(data.matches)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    async function payAction2(matchId) {
        setLoader(true);

        try {
            const data = await postData('/admin/settle/fixture', { matchId });
            setLoader(false);

            displayError('Settled successfully')
            setWithdrawals(data.matches)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    return (
        <div className='dashboard'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Fixtures</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Match ID</th>
                            <th>Home</th>
                            <th>Away</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withdrawals.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.id}</div>
                                    <div className="subtext">{w.date_time}</div>
                                </td>
                                <td>
                                    <div>{w.home.name}</div>
                                </td>
                                <td>
                                    <div>{w.away.name}</div>
                                </td>
                                <td>
                                    <div>{w.status}</div>
                                </td>
                                <td>
                                    {w.companyMatch ? <button className="btn decline" onClick={() => payAction(w.id, false)}>At Score: {w.score}</button> : <button className="btn approve" onClick={() => payAction(w.id, true)}>Set Company Match</button>}
                                    {w.status !== 'ENDED' && <button className="btn failed" onClick={() => payAction2(w.id)}>Settle Game</button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Fixtures